import * as React from "react";
import Profile from "@linkfluence/core/profile";
import {
  useCurrentUserProjects,
  useResetUserPassword,
  useUpdateCurrentUser,
} from "@radarly/core/user/use-cases";

interface IProps {
  onClose: () => void;
}

const RadarlySharedPanelsProfile = ({ onClose }: IProps) => {
  const updateUser = useUpdateCurrentUser();
  const { onResetPassword } = useResetUserPassword();

  const projects = useCurrentUserProjects();
  return (
    <Profile
      onClose={onClose}
      onUpdateUser={updateUser}
      projects={projects}
      onResetPassword={onResetPassword}
    />
  );
};

export default RadarlySharedPanelsProfile;
